import { FC, ReactNode } from 'react';
import classNames from 'classnames';

import { ModalBtn } from './Modal';

import { Slideout, SlideoutCommonProps } from '../Slideout';

type ConfirmModalProps = {
  submit: ModalBtn;
  cancel: ModalBtn;
  className?: string;
  title: ReactNode;
} & SlideoutCommonProps;

export const ConfirmModal: FC<ConfirmModalProps> = ({ submit, cancel, children, className, ...props }) => (
  <Slideout
    bodyClassName='d-flex flex-column'
    {...props}
    submit={{
      disabled: submit.disabled || submit.loading,
      onClick: submit.onClick,
      textClassname: submit.textClassname,
      loading: submit.loading,
      variant: submit.variant || 'primary',
      title: submit.title || 'Submit',
      testId: submit.testId,
      className: submit.className
    }}
    cancel={{
      className: cancel.className,
      onClick: cancel.onClick,
      variant: cancel.variant || 'secondary',
      loading: cancel.loading,
      textClassname: cancel.textClassname,
      disabled: cancel.disabled || cancel.loading,
      testId: cancel.testId
    }}
  >
    <div className={classNames('d-flex flex-column flex-1 justify-content-center text-center', className)}>
      {children}
    </div>
  </Slideout>
);
